<template>
  <section class="wrapper">
    <aside class="search">
      <van-search v-model="searchStr" placeholder="姓名/岗位"/>
    </aside>
    <aside class="opinion">
      <div class="title">审批意见</div>
      <van-field
        v-model="Remark"
        rows="1"
        :autosize="{minHeight: 150}"
        type="textarea"
        placeholder="请输入审批意见"
      />
      <van-index-bar>
        <div class="member-select">
          <van-checkbox v-model="checkAllFlag" @click="checkAll" shape="shape">全选</van-checkbox>
        </div>
        <van-checkbox-group ref="checkboxGroup" v-model="result" class="member-list">
          <van-checkbox :name="item" :class="result.includes(item)?'active':''" v-for="(item,index) in memberList"
                        :key="index" ref="checkbox" shape="shape">
            <van-row class="h5" style="width:100%" align="middle">
              <van-col span="12">{{item.DeptName}} {{item.PostName}} {{item.Employee}}</van-col>
              <!--              <van-col span="10" class="text-right" style="overflow:hidden;">{{item.Email}}</van-col>-->
            </van-row>
          </van-checkbox>
        </van-checkbox-group>
        <!--<van-index-anchor index="B" />
        <van-radio-group v-model="selectedStaffIds" class="member-list">
          <van-radio :name="member" :class="active" v-for="(member,index) in memberList"
                     :key="index">
            <van-row class="h5" style="width:100%">
              <van-col span="12">{{member.DeptName}} {{member.Employee}}</van-col>
              <van-col span="10" class="text-right">{{member.Email}}</van-col>
            </van-row>
          </van-radio>
        </van-radio-group>-->
      </van-index-bar>
    </aside>
    <div class="pr5 pl5 mt10">
      <van-button block type="info" @click="countersignForm">提交</van-button>
    </div>
  </section>
</template>

<script>
  import {getStaffListApi} from '@/api/common'
  import {countersignFormApi} from '@/api/reimbursement'

  export default {
    data() {
      return {
        searchStr: '',//搜索内容
        checkAllFlag: false,//全选判断标识
        ApprovalGuid: this.getCookie("ApproveDetail") != null ? this.getCookie("ApproveDetail").guid : '',//审批GUID
        Remark: '',//审核意见
        result: [],//选中的员工数据
        memberList: []
      }
    },
    mounted() {
      this.getStaffList();
    },
    watch: {
      // 监听选中单元，判断全选控件
      'result'(val) {
        // 如果有禁止选中的，则忽略它
        let count = 0;
        for (let i = 0; i < this.memberList.length; i++) {
          if (this.$refs.checkbox[i].disabled === true && this.$refs.checkbox[i].checked === false) {
            count++;
          }
        }
        if (val.length !== this.memberList.length - count) {
          this.checkAllFlag = false
        } else {
          this.checkAllFlag = true
        }
      },
    },
    methods: {
      //全选
      checkAll() {
        // 点击可切换模式
        this.checkAllFlag = !this.checkAllFlag;
        // 全选，并且跳过默认禁止点击的选框
        this.$refs.checkboxGroup.toggleAll({
          checkAllFlag: this.checkAllFlag
        });
      },
      //获取人员列表
      async getStaffList() {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
        };
        let response = await getStaffListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            if (response.result != null && response.result.length > 0) {
              this.memberList = response.result;
            }
          }
        }
      },
      //加签
      async countersignForm() {
        if (this.$route.query == null) {
          this.$toast.fail("加签数据不能为空");
          return;
        }
        if (this.result == null || this.result.length < 1) {
          this.$toast.fail("请选择加签人员");
          return;
        }
        let staffids = '';//加签人员Id
        this.result.forEach((item, index) => {
          staffids = staffids + item.StaffId + ":" + item.PostsetGUID + ",";
        });
        let companyInfo = this.getCookie("CompanyInfo");
        let userInfo = this.getCookie("UserInfo");
        let params = {
          cGuid: companyInfo.companyId,
          companyName: companyInfo.companyName,
          uGuid: userInfo.U_GUID,
          Remark: this.Remark,
          approvalGuids: this.$route.query.guid,
          staffIds: staffids
        };
        let response = await countersignFormApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.$toast.success(response.msg);
            this.$router.push({
              path: '/approval/detail', query: {
                guid: this.$route.query.guid,
              }
            });
            return;
          }
          this.$toast.fail(response.msg);
          return;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    background: #f0f0f0;
    height: 100%;

    .search {
      margin: .5rem;
    }

    .opinion {
      background: white;
      margin: .5rem;

      ::v-deep.van-field__control {
        border: solid 1px #dbdbdb;
        padding: 1rem;
        background: #f8f8f8;
        border-radius: 4px;
      }

      .title {
        font-size: 1.6rem;
        padding: 1.5rem;
      }
    }

    .member-select {
      padding: 1rem;

      ::v-deep.van-checkbox {
        border-radius: 4px;
        padding-left: 1rem;
        padding-right: 1rem;
      }

      ::v-deep.van-checkbox__label {
        flex: 1;
      }
    }

    .member-list {
      padding: 1rem;
      max-height: 200px;
      overflow: auto;

      ::v-deep.van-checkbox {
        border: solid 1px #cccccc;
        border-radius: 4px;
        margin-bottom: 1rem;
        padding: 1rem;
      }

      ::v-deep.van-checkbox__label {
        flex: 1;
      }

      .active {
        background: #09a5bb;

        ::v-deep.van-checkbox__label {
          color: white;
        }

        ::v-deep.van-checkbox__icon--checked .van-icon {
          color: #09a5bb;
          background-color: #fff;
          border-color: #fff;
        }
      }
    }

    ::v-deep.van-button--info {
      background: #1c84c6;
      border: #1c84c6;
    }
  }
</style>
